import { useEffect, useState } from "react";
import { Select, Text } from "@chakra-ui/react";
import { getEmployees } from "../hooks/employees";
import { Employee } from "../utils/types";





export const EmployeeDropdown = ({
  organizationId,
//   selectedEmployeeId,
  onChange,
}: {
  organizationId: string;
//   selectedEmployeeId: number | null;
  onChange: (value: string) => void;
}) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | undefined>();
  // const selectedEmployee = employees.find(emp => emp.id === selectedEmployeeId);

  useEffect(() => {
    const fetchEmployees = async () => {
        if (organizationId) {
        try {
            const response = await getEmployees(organizationId);
            console.log('Employee response', response?.data);
            setEmployees(response?.data);
        } catch (error) {
            console.error("Failed to load employees:", error);
        }
        }
    };

    fetchEmployees();
    }, [organizationId]);

    useEffect(() => {
        const setEmployee = async () => {
            if(selectedEmployeeId){
                onChange(selectedEmployeeId);
            }
        };
        setEmployee();
    }, [selectedEmployeeId]);

  return (
    <>
    <Text>Assigned to:</Text>
    <Select 
        placeholder='Select Employee'
        value={selectedEmployeeId}
        onChange={(e) => setSelectedEmployeeId(e.target.value)}
    >
        {employees
            .filter((emp) => emp.user !== null)
            .map((emp) => (
                <option key={emp.id} value={emp.id}>
                {emp.user.first_name + " - " + emp.role}
                </option>
        ))}
    </Select>
    </>
  );
};
